import React from 'react';
import { Table, Image, Badge, Button, Spinner, Row, Col } from 'react-bootstrap';
import { FaAngleRight } from 'react-icons/fa';
import { Order } from '../types';
import { base_url } from '../../../Api/ApiConst';
import noProduct from '../../../assets/images/no-product.png';
import { useTranslation } from 'react-i18next';
import { getImageUrl } from "../../../Utils/imageUtils";

interface OrderTableProps {
  orders: Order[];
  loading: boolean;
  styles: any;
  onOrderClick: (orderId: string) => void;
  onUpdateOrder: (orderId: string, status: string, deliveryMethod: string) => void;
}

const OrderTable: React.FC<OrderTableProps> = React.memo(({
  orders,
  loading,
  styles,
  onOrderClick,
  onUpdateOrder
}) => {
  const { t } = useTranslation();

  return (
    <>
      {loading && (
        <Row>
          <Col className="d-flex align-items-center justify-content-center">
            <Spinner animation="grow" variant="primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        </Row>
      )}
      <div className="table-responsive">
        <Table hover style={styles.orderTable} className="productTable">
          <tbody>
            {!loading && orders.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <h3 style={styles.noProduct}>
                  <Image
                    src={noProduct}
                    className="mx-2"
                    style={{ width: 32, height: 32 }}
                  />{" "}
                  {t("userProfile.noOrdersFound")}
                </h3>
              </div>
            ) : (
              !loading &&
              orders.length !== 0 &&
              orders &&
              orders.map((item: any) => {
                return (
                  <tr
                    key={item.id}
                  // onClick={() => handleClick(item.id)}
                  // style={{ cursor: "pointer" }}
                  >
                    <td className="hide-xs">
                      {" "}
                      <input
                        type="radio"
                        name="productSelect"
                        style={styles.orderRadio}
                      />
                    </td>
                    <td>
                      <div style={styles.orderImageWrap}>
                        <Image
                          src={getImageUrl(item?.order_details[0]?.product?.product_image)}
                          style={styles.orderImage}
                        />
                        {item?.order_details.length > 1 && (
                          <Badge
                            style={{
                              position: "absolute" as React.CSSProperties["position"],
                              top: 0,
                              right: 0,
                            }}
                            bg="danger"
                          >
                            + {item?.order_details.length - 1} items
                          </Badge>
                        )}
                      </div>

                    </td>
                    <td style={styles.orderInfo}>{item.id}</td>
                    <td style={styles.orderInfo}>
                      {String(item.purchase_date).split("T")[0]}
                    </td>
                    <td style={styles.orderInfo}>रु {item.total_amount}</td>
                    <td style={styles.completed}>
                      {item.store_order_status.status}
                    </td>
                    <td style={styles.orderInfo}>
                      <Button
                        className="btnBlue"
                        onClick={() =>
                          onUpdateOrder(
                            item.id,
                            item.store_order_status.status,
                            item.delivery_method

                          )
                        } // Pass the correct status
                        disabled={
                          !item.store_order_status.can_change ||
                          item.status === "Delivered" ||
                          item.status === "Cancelled"
                        } // Disable condition
                      >
                        Update Order
                      </Button>
                    </td>
                    {/* <td style={styles.orderInfo}>411052</td> */}
                    <td style={styles.orderInfo}>
                      <FaAngleRight
                        onClick={() => onOrderClick(item.id)}
                        style={{ cursor: "pointer", fontSize: 24 }}
                      />
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
});

OrderTable.displayName = 'OrderTable';

export default OrderTable;